
import { mapMutations, mapState } from 'vuex';

import Product from '@/components/shop/product.vue';
import LoadMore from '@/components/ui/loadMore.vue';
import EmptyState from '~/components/ui/emptyState.vue';

export default {
  name: 'MyProducts',

  components: {
    Product,
    LoadMore,
    EmptyState,
  },

  layout: 'cat',

  data() {
    return {
      page: 1,
      lastPage: null,
      perPage: 12,
      loading: false,
      noProducts: false,
    };
  },

  computed: {
    ...mapState(['myProducts', 'user', 'products']),

    filteredProducts() {
      return this.$store.getters.filterProducts(this.myProductsOnly);
    },

    sortedProducts() {
      // eslint-disable-next-line
      return this.$store.getters.sortProducts(this.filteredProducts);
    },

    myProductsOnly() {
      return this.products.filter((p) => this.myProducts.includes(p.sku));
    },
  },

  async mounted() {
    if (this.user === null) {
      this.$router.push(this.localePath({ name: 'shop' }));
    }
    if (this.myProducts.length) {
      const { data, headers } = await this.$wc.products({
        perPage: this.perPage,
        page: this.page,
        sku: this.myProducts,
      });
      if (data && data.length) {
        this.setProducts(data);
        this.page++;
        if (headers['x-wp-totalpages']) {
          this.lastPage = parseInt(headers['x-wp-totalpages']);
        }
      }
    } else {
      // this.$router.push(this.localePath({ name: 'shop' }));
      this.noProducts = true;
    }
  },

  methods: {
    ...mapMutations(['setProducts', 'setMyProducts']),

    async getProducts() {
      const { data, headers } = await this.$wc.products({
        perPage: this.perPage,
        page: this.page,
        sku: this.myProducts,
      });
      if (data && data.length) {
        this.setProducts(data);
        this.page++;
        if (headers['x-wp-totalpages']) {
          this.lastPage = parseInt(headers['x-wp-totalpages']);
        }
      }
    },
  },
};
